import { makeStyles } from "@material-ui/core/styles";
import { ratingColors } from "../theme";

const ratingLabels = ["HMMMMM", "HMMm", "Ehhh", "BLEHHH"] as const;

export type RatingChipProps = {
  id?: string;
  rating: number;
};

const useStyles = makeStyles({
  chip: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 6,
    fontSize: "0.7rem",
    fontWeight: 600,
    letterSpacing: 0.3,
    lineHeight: 1.4,
  },
});

const RatingChip = ({ id, rating }: RatingChipProps) => {
  const classes = useStyles();
  const idx = Math.max(1, Math.min(4, rating)) - 1;
  const color = ratingColors[idx];
  return (
    <span
      id={id}
      className={classes.chip}
      style={{ color, backgroundColor: `${color}1E` }}
    >
      {ratingLabels[idx]} ({idx + 1})
    </span>
  );
};

export default RatingChip;
